import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getCountries } from "ticketino-api-client";

import Header from "./components/Header";

const SponsorSpeaker_Step20_Address = () => {
    const [order, setOrder] = useState({});
    const [orderId, setOrderId] = useState();
    const [organizerId, setOrganizerId] = useState(0);

    const [address, setAddress] = useState([]);

    const [countries, setCountries] = useState([]);

    const [token, setToken] = useState(sessionStorage.getItem("token"));

    const [buyerInfo, setBuyerInfo] = useState({
        firstName: "",
        name: "",
        company: "",
        function: "",
        telephone: "",
        mobile: "",
        street: "",
        postCode: "",
        city: "",
        email: "",
        countryId: 0,
    });

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        case ("en" || "EN"):
            languageId = 3;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        const loadToken = async () => {
            try {
                const res = await axios.get("form/token");
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
                await sessionStorage.setItem("token", res.data);
                setToken(res.data);
                requestFormSettings();
            } catch (error) {
                console.error(error);
            }
        };

        let currentOrderId = sessionStorage.getItem("orderId");

        if (currentOrderId > 0) {
            setOrderId(currentOrderId);
        }

        const requestFormSettings = async () => {
            try {
                const res = await axios.get(`form/formsettings`);

                if (currentOrderId > 0) {
                    loadOrder(currentOrderId);
                    loadAddress(currentOrderId);
                } else {
                    sessionStorage.removeItem("addedPromotion"); // clear promotion code
                    navigate("/de/sponsor-speaker/home");
                }

                setOrganizerId(res.data.organizerId)
            } catch (error) {
                console.error(error);
            }
        };

        loadToken();
    }, []);

    useEffect(() => {
        if (token && language) {
            requestResources();
            loadCountries();
        }
    }, [language, token]);

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const loadCountries = async () => {
        try {
            let updatedCountries = await getCountries(language);

            const indexCh = updatedCountries.findIndex(c => c.id == 176);
            const indexDe = updatedCountries.findIndex(c => c.id == 229);
            const indexAu = updatedCountries.findIndex(c => c.id == 228);

            const ch = updatedCountries[indexCh];
            const de = updatedCountries[indexDe];
            const au = updatedCountries[indexAu];

            updatedCountries.splice(indexCh, 1);
            updatedCountries.splice(indexDe, 1);
            updatedCountries.splice(indexAu, 1);

            updatedCountries.unshift(au);
            updatedCountries.unshift(de);
            updatedCountries.unshift(ch);

            setCountries(updatedCountries);

        } catch (error) {
            console.error(error);
        }
    }

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                navigate("/de/sponsor-speaker/home");
            }
        }
    }

    const getAddressByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/Order/${orderId}/Address`)
            return res.data;
        }
        catch (error) {
            console.error(error);
        }
    }

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            if (updatedOrder === null) {
                navigate("/de/sponsor-speaker/home")
            }

            setOrder(updatedOrder);
        }
        catch (error) {
            console.error(error);
        }
    }

    const loadAddress = async (orderId) => {
        try {
            // address
            const address = await getAddressByOrderId(orderId);

            setAddress(address);
        }
        catch (error) {
            console.error(error);
        }
    }

    const handleInputChange = (e) => {
        setBuyerInfo({ ...buyerInfo, [e.target.name]: e.target.value });
    };

    const onSubmit = async () => {
        const updatedBuyerInfo = { ...buyerInfo};
        setBuyerInfo(updatedBuyerInfo);
        await addAddressToBasket(updatedBuyerInfo);
    }

    const addAddressToBasket = async (buyerInfoToSend = buyerInfo) => {

        // Retrieve opion1 from sessionStorage
        const code1 = localStorage.getItem("SponsorSpeakerOption1");

        if (!code1) {
            navigate("/de/sponsor-speaker/home");
            return;
        }

        let addressBody = {
            code1: code1,
            firstName: buyerInfoToSend.firstName,
            name: buyerInfoToSend.name,
            company: buyerInfoToSend.company,
            function: buyerInfoToSend.function,
            email: buyerInfoToSend.email,
            telephone: buyerInfoToSend.telephone,
            mobile: buyerInfoToSend.mobile,
            street: buyerInfoToSend.street,
            postCode: buyerInfoToSend.postCode,
            city: buyerInfoToSend.city,
            countryId: buyerInfoToSend.countryId,
        };

        await axios
            .put(`${baseUrl}/Order/${orderId}/Address`, addressBody)
            .then(() => {

                //// gtm - addAddress
                //window.dataLayer = window.dataLayer || [];
                //window.dataLayer.push({
                //    'event': 'addAddress'
                //});

                sessionStorage.setItem("FinanzOrderAddress", JSON.stringify(addressBody));
                navigate(`/${language}/sponsor-speaker/ticket-address`)
            })
            .catch((error) => {
                console.error(error.response.data);
                navigate("/de/sponsor-speaker/home")
            });
    };

    // Validation for mandatory fields
    const validation =
        buyerInfo.firstName && buyerInfo.firstName.trim() !== "" &&
        buyerInfo.name && buyerInfo.name.trim() !== "" &&
        buyerInfo.company && buyerInfo.company.trim() !== "" &&
        buyerInfo.street && buyerInfo.street.trim() !== "" &&
        buyerInfo.postCode && buyerInfo.postCode.trim() !== "" &&
        buyerInfo.city && buyerInfo.city.trim() !== "" &&
        buyerInfo.email && buyerInfo.email.trim() !== "" &&
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(buyerInfo.email) &&
        buyerInfo.countryId && buyerInfo.countryId !== 0;

    useEffect(() => {
        if (address && address.id) {
            setBuyerInfo(prev => ({
                ...prev,
                firstName: address.firstName || "",
                name: address.name || "",
                company: address.company || "",
                function: address.function || "",
                telephone: address.telephone || "",
                mobile: address.mobile || "",
                street: address.street || "",
                postCode: address.postCode || "",
                city: address.city || "",
                email: address.email || "",
                countryId: address.countryId || 0,
            }));
        }
    }, [address]);

    return (
        <div className="page-container">
            <Header language={language} />
            <div className="container wrapper-small">

                <div className="row mt-2">
                    <div className="col-md-12">
                        <span className="text-title d-block">{resources?.EventName}</span>
                        <span className="text-subtitle d-block">{resources?.VisitorAddressTitle}</span>
                    </div>
                </div>

                <div className="row mt-4">

                    {/* first name */}
                    <div className="col-md-6 mb-3">
                        <label>{resources?.VisitorAddressFirstName}</label>
                        <input
                            type="text"
                            name="firstName"
                            className="form-control mt-2"
                            value={buyerInfo.firstName}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* last name */}
                    <div className="col-md-6 mb-3">
                        <label>{resources?.VisitorAddressLastName}</label>
                        <input
                            type="text"
                            name="name"
                            className="form-control mt-2"
                            value={buyerInfo.name}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* company */}
                    <div className="col-md-6 mb-3">
                        <label>{resources?.VisitorAddressCompany}</label>
                        <input
                            type="text"
                            name="company"
                            className="form-control mt-2"
                            value={buyerInfo.company}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* function */}
                    <div className="col-md-6 mb-3">
                        <label>{resources?.SponsorSpeakerAddressFunction}</label>
                        <input
                            type="text"
                            name="function"
                            className="form-control mt-2"
                            value={buyerInfo.function}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* email */}
                    <div className="col-md-12 mb-3">
                        <label>{resources?.VisitorAddressEmail}</label>
                        <input
                            type="email"
                            name="email"
                            className="form-control mt-2"
                            value={buyerInfo.email}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* phone */}
                    <div className="col-md-6 mb-3">
                        <label>{resources?.VisitorAddressPhone}</label>
                        <input
                            type="text"
                            name="telephone"
                            className="form-control mt-2"
                            value={buyerInfo.telephone}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* mobile */}
                    <div className="col-md-6 mb-3">
                        <label>{resources?.VisitorAddressMobile}</label>
                        <input
                            type="text"
                            name="mobile"
                            className="form-control mt-2"
                            value={buyerInfo.mobile}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* address */}
                    <div className="col-md-12 mb-3">
                        <label>{resources?.VisitorAddressAddress}</label>
                        <input
                            type="text"
                            name="street"
                            className="form-control mt-2"
                            value={buyerInfo.street}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* ZIP */}
                    <div className="col-md-6 mb-3">
                        <label>{resources?.VisitorAddressZip}</label>
                        <input
                            type="text"
                            name="postCode"
                            className="form-control mt-2"
                            value={buyerInfo.postCode}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* City */}
                    <div className="col-md-6 mb-3">
                        <label>{resources?.VisitorAddressCity}</label>
                        <input
                            type="text"
                            name="city"
                            className="form-control mt-2"
                            value={buyerInfo.city}
                            onChange={handleInputChange}
                        />
                    </div>

                    {/* country */}
                    <div className="col-md-12 mb-3">
                        <label>{resources?.VisitorAddressCountry}</label>
                        <select
                            className="form-select mt-2"
                            name="countryId"
                            value={buyerInfo.countryId}
                            onChange={handleInputChange}
                        >
                            <option value=""></option>
                            {countries.map((country) => (
                                <option key={country.id} value={country.id}>{country.name}</option>
                            ))}
                        </select>
                    </div>
                </div> 

                <div className="row mt-4">
                    <div className="col-md-6">
                        <button className="btn button-custom" onClick={() => navigate(-1)}>{resources?.Back}</button>
                    </div>
                    <div className="col-md-6 text-end">
                        <button className="btn button-custom" onClick={() => onSubmit()} disabled={!validation}>{resources?.Next}</button>
                    </div>
                </div>

                <p className="mt-4">
                    <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                </p>
            </div> 
        </div>
    )
}

export default SponsorSpeaker_Step20_Address